import { Component } from '@angular/core';

@Component({
  selector: 'app-section-quero-incubar',
  templateUrl: './section-quero-incubar.component.html',
  styleUrls: ['./section-quero-incubar.component.scss'],
})
export class SectionQueroIncubarComponent {}
